<button
  [ngClass]="['rounded-button', isActive ? 'active': '', buttonStyle]"
  [type]="type"
  (click)="buttonClick.emit()">
    <span class="rounded-button-text">{{text}}</span>
</button>
